import { lazy } from 'react';

import Loadable from 'shared/components/ui-component/Loadable';
import { APPLICATION_ROUTES } from 'constants/routes';
import OwnerGuard from '../shared/utils/route-guard/OwnerGuard';
import MainLayout from '../shared/components/layout/MainLayout';

/** Lazy-loaded IngredientsPage component */
const IngredientsPage = Loadable(lazy(() => import('pages/ingredients')));

/**
 * Routes configuration for the ingredients module
 * Includes protected routes that require owner access
 *
 * @type {Object} Route configuration object containing:
 *   - path: Base path for the routes
 *   - element: Root element with owner guard and main layout
 *   - children: Array of child routes including the ingredients page
 */
const IngredientsRoutes = {
    path: '/',
    element: (
        <OwnerGuard>
            <MainLayout />
        </OwnerGuard>
    ),
    children: [
        {
            path: APPLICATION_ROUTES.products,
            element: <IngredientsPage />
        }
    ]
};

export default IngredientsRoutes;
